import * as yup from "yup";
import {SeoSchema,} from "../../configs/constants";

export const PageInputSchema = (t) => SeoSchema().shape({
    title: yup.string().label(t("title")).max(512).required(),
    description: yup.string().max(500).label(t("description")),
})
export const PageEditSchema = PageInputSchema;
